/**
 * As ações rápidas do Brain: as 12 da tela inicial — as do original eram de
 * código e design; aqui são de clínica, só com o que o servidor faz de verdade
 * (as ferramentas de leitura da B1, gerar arquivo e propor ação) — e as
 * sugestões do painel à direita, conforme o módulo em que a pessoa está.
 */

export interface AcaoRapida {
    icone: string;
    titulo: string;
    prompt: string;
}

export const ACOES_RAPIDAS: AcaoRapida[] = [
    { icone: 'calendar-days', titulo: 'Agenda de hoje', prompt: 'Mostre os agendamentos de hoje, por horário e profissional.' },
    { icone: 'calendar-clock', titulo: 'Horários livres', prompt: 'Quais horários estão livres na agenda de amanhã?' },
    { icone: 'users', titulo: 'Buscar paciente', prompt: 'Vou dizer um nome: busque o contato e mostre os dados principais.' },
    { icone: 'wallet', titulo: 'Resumo financeiro', prompt: 'Resuma o financeiro deste mês: entradas, saídas e saldo.' },
    { icone: 'receipt', titulo: 'Contas a vencer', prompt: 'Quais contas vencem nos próximos 7 dias?' },
    { icone: 'package', titulo: 'Estoque baixo', prompt: 'Quais produtos estão abaixo do estoque mínimo?' },
    { icone: 'file-text', titulo: 'Orçamentos em aberto', prompt: 'Liste os orçamentos em aberto, do maior para o menor valor.' },
    { icone: 'target', titulo: 'Funil do CRM', prompt: 'Como está o funil do CRM? Quantos leads em cada etapa?' },
    { icone: 'bar-chart-3', titulo: 'Relatório do mês', prompt: 'Faça o relatório do mês: atendimentos, faturamento e destaques.' },
    { icone: 'table', titulo: 'Planilha da semana', prompt: 'Gere uma planilha com os agendamentos desta semana.' },
    { icone: 'list-todo', titulo: 'Criar tarefa', prompt: 'Quero criar uma tarefa. Me pergunte o título, o prazo e o responsável, e proponha para eu confirmar.' },
    { icone: 'sparkles', titulo: 'Revisar meu texto', prompt: 'Vou colar um texto. Revise clareza, concisão e tom, e me devolva a versão final com um resumo do que mudou.' },
];

const SUGESTOES: Record<string, AcaoRapida[]> = {
    inicio: [
        { icone: 'calendar-days', titulo: 'Agenda de hoje', prompt: 'Mostre os agendamentos de hoje, por horário e profissional.' },
        { icone: 'bar-chart-3', titulo: 'Relatório do mês', prompt: 'Faça o relatório do mês: atendimentos, faturamento e destaques.' },
        { icone: 'receipt', titulo: 'Contas a vencer', prompt: 'Quais contas vencem nos próximos 7 dias?' },
    ],
    agenda: [
        { icone: 'calendar-days', titulo: 'Agenda de hoje', prompt: 'Mostre os agendamentos de hoje, por horário e profissional.' },
        { icone: 'calendar-clock', titulo: 'Horários livres', prompt: 'Quais horários estão livres na agenda de amanhã?' },
        { icone: 'calendar-plus', titulo: 'Agendar retorno', prompt: 'Quero agendar um retorno. Me pergunte o paciente, o dia e o horário, e proponha para eu confirmar.' },
    ],
    contatos: [
        { icone: 'users', titulo: 'Buscar paciente', prompt: 'Vou dizer um nome: busque o contato e mostre os dados principais.' },
        { icone: 'user-plus', titulo: 'Novo lead', prompt: 'Quero cadastrar um lead. Me pergunte nome e telefone, e proponha para eu confirmar.' },
    ],
    crm: [
        { icone: 'target', titulo: 'Funil do CRM', prompt: 'Como está o funil do CRM? Quantos leads em cada etapa?' },
        { icone: 'users', titulo: 'Leads parados', prompt: 'Quais leads estão parados há mais tempo na mesma etapa?' },
    ],
    financeiro: [
        { icone: 'wallet', titulo: 'Resumo do mês', prompt: 'Resuma o financeiro deste mês: entradas, saídas e saldo.' },
        { icone: 'receipt', titulo: 'Contas a vencer', prompt: 'Quais contas vencem nos próximos 7 dias?' },
    ],
    estoque: [
        { icone: 'package', titulo: 'Estoque baixo', prompt: 'Quais produtos estão abaixo do estoque mínimo?' },
    ],
    vendas: [
        { icone: 'file-text', titulo: 'Orçamentos em aberto', prompt: 'Liste os orçamentos em aberto, do maior para o menor valor.' },
    ],
    relatorios: [
        { icone: 'bar-chart-3', titulo: 'Relatório do mês', prompt: 'Faça o relatório do mês: atendimentos, faturamento e destaques.' },
        { icone: 'table', titulo: 'Planilha da semana', prompt: 'Gere uma planilha com os agendamentos desta semana.' },
    ],
};

/** As sugestões do painel para o módulo aberto; fora dos módulos conhecidos, as da tela inicial. */
export function sugestoesDoModulo(modulo: string | undefined): AcaoRapida[] {
    return (modulo ? SUGESTOES[modulo] : undefined) ?? ACOES_RAPIDAS.slice(0, 6);
}
